import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles((theme: Theme) => ({
  mainDiv: {
    display: "flex",
    flexDirection: "column",
    minHeight: "calc(100vh - 56px)",
    [theme.breakpoints.up("md")]: {
      minHeight: "calc(100vh - 64px)",
    },
  },

  contentRow: {
    display: "flex",
    alignItems: "stretch",
    flex: 1,
    minHeight: 0,
  },

  contentArea: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
  },

  childrenDiv: {
    backgroundColor: "#FFFFFF",
    flex: 1,
    minHeight: 0,
  },
}));

export default styles;
